import {
    CREATE_ACTIVESHARABLELINKS,
    RETRIEVE_ACTIVESHARABLELINKS,
    RETRIEVEMENU_ACTIVESHARABLELINKS,
    RETRIEVESINGLE_ACTIVESHARABLELINKS,
    UPDATE_ACTIVESHARABLELINKS,
    DELETE_ACTIVESHARABLELINKS,
  } from "../actions/type";
  const initialState = [];
  function ActiveSharableLinksReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ACTIVESHARABLELINKS:
        return {data: state.data, payload};
      case RETRIEVE_ACTIVESHARABLELINKS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVEMENU_ACTIVESHARABLELINKS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ACTIVESHARABLELINKS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ACTIVESHARABLELINKS:
        return {data: state.data, payload};
      case DELETE_ACTIVESHARABLELINKS:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ActiveSharableLinksReducer};